const cartHasResale = (resaleOrderItems) =>
  (resaleOrderItems || []).some((item) => item.quantity && item.quantity > 0);

export const cartIsResaleOnly = (resaleOrderItems, ticketTypes, addOns) =>
  cartHasResale(resaleOrderItems)
    && !(ticketTypes || []).some((tt) => tt.quantity && tt.quantity > 0)
    && !(addOns || []).some((ao) => ao.quantity && ao.quantity > 0);

export default cartHasResale;
